// extracted by mini-css-extract-plugin
export default {"testContainer":"UserTestContainer_testContainer__mTP8q","testHeader":"UserTestContainer_testHeader__gDjxj","miniHeader":"UserTestContainer_miniHeader__1tSvD"};